import { jsx as _jsx } from "react/jsx-runtime";
import React, { Component } from 'react';
import amplitude from 'amplitude-js';
import Issue from './Issue';
class QuickFixes extends Component {
    generateQuickFixIssue(filesByExtensions, fileExtension, extraIssuesByExtensions) {
        const { reportsFiles } = this.props;
        const files = Object.keys(filesByExtensions)
            // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'FilesByExtension'.
            .filter((file) => file === fileExtension && filesByExtensions[file].length > 0)
            // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'FilesByExtension'.
            .map((extension) => filesByExtensions[extension]);
        // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'FilesByExtension'.
        let issueCount = extraIssuesByExtensions[fileExtension];
        issueCount += Object.values(reportsFiles).reduce((acc, file) => {
            // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'FilesByExtension'.
            return filesByExtensions[fileExtension].includes(file.filePath)
                ? acc + file.errorCount + file.warningCount
                : acc;
        }, 0);
        return {
            isError: false,
            options: {
                files: files,
                issuesCount: issueCount,
            },
            quickFix: true,
        };
    }
    render() {
        const { match, commit, filesByExtensions, extraIssuesByExtensions } = this.props;
        const quickFixIssueJS = this.generateQuickFixIssue(filesByExtensions, 'js', extraIssuesByExtensions);
        const quickFixIssuePHP = this.generateQuickFixIssue(filesByExtensions, 'php', extraIssuesByExtensions);
        const eventData = {
            commitHash: commit.hash,
            commitId: commit.id,
            repositoryFullname: `${match.params.owner}/${match.params.repository}`,
        };
        return Object.keys(filesByExtensions).map((extension) => {
            // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'FilesByExtension'.
            const showMessage = !!(filesByExtensions[extension].length
                ? extension === 'php'
                    ? quickFixIssuePHP.options.issuesCount
                    : quickFixIssueJS.options.issuesCount
                : false);
            //@ToDo: Add Smartlook event
            if (showMessage) {
                amplitude.getInstance().logEvent('show-quick-fixes-message-' + extension, eventData);
                const issue = extension === 'php' ? quickFixIssuePHP : quickFixIssueJS;
                return (_jsx("div", { className: "commit-issues mt-4", children: _jsx(Issue, { className: "commit-issues__item--quick-fix", issue: issue, extension: extension }) }));
            }
            // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'FilesByExtension'.
            if (filesByExtensions[extension].length) {
                // Is this really helping us figure out if the user used the quick fix from last commit?
                amplitude.getInstance().logEvent('dont-show-quick-fixes-message-' + extension, eventData);
            }
            return null;
        });
    }
}
export default QuickFixes;
